/**
 * Which deployment this build is. The isolated staging copy (D132, D138) is
 * built with REACT_APP_ENV=staging; production leaves it unset.
 *
 * In staging, everything that only makes sense against production is turned
 * off here, explicitly, before any request goes out: checkout, the billing
 * portal and plan changes, pausing a subscription, add-ons, consulting
 * checkout, the cohort email sender, and the Meta Pixel. It doesn't rely on
 * production refusing a staging sign-in. stagingGuards.test.js fails if a
 * page calls one of those endpoints without this check.
 */
export const IS_STAGING = process.env.REACT_APP_ENV === "staging";

export const STAGING_OFF = (what) => `${what} is turned off in staging.`;

/** Throws before a production-only action, in staging. Call it inside the action's own try. */
export function assertNotStaging(what) {
  if (IS_STAGING) throw new Error(STAGING_OFF(what));
}
